import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategoriesGrid from "./components/CategoriesGrid";
import WhatIsSection from "./components/WhatIsSection";
import ComparisonTable from "./components/ComparisonTable";
import TrustSection from "./components/TrustSection";
import SafetySection from "./components/SafetySection";
import ArticlesSection from "./components/ArticlesSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import { SITE_URL } from "@/constants";

const siteUrl = SITE_URL;

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesGrid />
        <WhatIsSection />
        <ComparisonTable />
        <TrustSection />
        <SafetySection />
        <ArticlesSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "AllChinaBuy Spreadsheet",
        "url": siteUrl,
        "description": "Discover the best AllChinaBuy Spreadsheet with verified products, trusted sellers, buying guides, and updated product lists.",
        "potentialAction": {
          "@type": "SearchAction",
          "target": siteUrl + "search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      }) }}></script>
    </>
  );
}